/**
 * CurrencyStep - Display currency picker (EUR/USD/CHF). Default EUR.
 */

import React, { useState } from 'react';
import { useLang } from '../../../shared/i18n';
import { authApi } from '../../../services/authApi';
import { getPreferredCurrency, setPreferredCurrency } from '../../../utils/currency';

const CHOICES: { code: string; symbol: string; labelKey: string }[] = [
    { code: 'EUR', symbol: '€', labelKey: 'onboardingCurrencyEUR' },
    { code: 'USD', symbol: '$', labelKey: 'onboardingCurrencyUSD' },
    { code: 'CHF', symbol: 'Fr', labelKey: 'onboardingCurrencyCHF' },
];

const CurrencyStep: React.FC = () => {
    const { t } = useLang();
    const [selected, setSelected] = useState<string>(() => {
        const cur = getPreferredCurrency();
        return ['EUR', 'USD', 'CHF'].includes(cur) ? cur : 'EUR';
    });

    const handleSelect = (code: string) => {
        setSelected(code);
        setPreferredCurrency(code);
        authApi.updatePreferences({ display_currency: code });
    };

    return (
        <div className="wizard-step wizard-step--currency">
            <h2 className="wizard-step__title">{t('onboardingCurrencyTitle')}</h2>
            <p className="wizard-step__desc">{t('onboardingCurrencyDesc')}</p>

            <div className="currency-cards">
                {CHOICES.map(({ code, symbol, labelKey }) => (
                    <button
                        key={code}
                        className={`currency-card ${selected === code ? 'currency-card--selected' : ''}`}
                        onClick={() => handleSelect(code)}
                    >
                        <span className="currency-card__symbol">{symbol}</span>
                        <span className="currency-card__code">{code}</span>
                        <span className="currency-card__label">{t(labelKey)}</span>
                        {selected === code && <span className="currency-card__check">&#10003;</span>}
                    </button>
                ))}
            </div>

            <p className="wizard-step__hint">{t('onboardingCurrencyHint')}</p>
        </div>
    );
};

export default CurrencyStep;
